const statisticDefinitions = [
  {
    page: '1',
    variant: 'banner',
    left: '80%',
    top: '55%',
    // width: '15%',
    parallax: 0.19,
    content: [
      { type: 'number', value: 690, emphasis: true },
      { type: 'text', value: 'Black balls tumbling\ndown the stairs', mobileValue: 'Black balls tumbling down the stairs' },
    ],
    mobile: { left: '15%', top: '60%', width: '70%' },
  },
  {
    page: '4',
    variant: 'banner',
    left: '20%',
    bottom: '10%',
    content: [
      { type: 'number', value: 3, suffix: ' DAYS', emphasis: true },
      { type: 'text', value: 'Filming at 9,850 feet above sea\nlevel. Real mountains. Real snow.' },
    ],
    mobile: { left: '8%', bottom: '20%', width: '80%', stacked: true },
  },
  {
    page: '5',
    variant: 'banner',
    left: '37%',
    top: '25%',
    content: [
      { type: 'number', value: 1000, emphasis: true },
      { type: 'text', value: 'People behind\nthe production' },
    ],
    mobile: { left: '17%', top: '53%', width: '65%'},
  },
  {
    page: '12',
    variant: 'banner',
    right: '7%',
    bottom: '10%',
    parallax: '0',
    countUpSpeed: 2,
    content: [
      { type: 'number', value: 369, suffix: 'K', emphasis: true },
      { type: 'text', value: 'feet of\n35mm film' },
    ],
    mobile: { left: '25%', bottom: '4%', width: '50%',
      countUpSpeed: 15, parallax: 0 },
  },
  {
    page: '14',
    variant: 'banner',
    right: '5%',
    top: '10%',
    content: [
      { type: 'number', value: 557 },
      { type: 'text', value: 'spins\nby Milo' },
    ],
    mobile: { left: '30%', bottom: '10%', width: '40%' },
  },
  {
    page: '19',
    variant: 'banner',
    right: '-5%',
    top: '47%',
    content: [
      { type: 'number', value: 1, suffix: ' MONTH', emphasis: true, },
      { type: 'text', value: 'to build a village.\nOne moment to destroy it.' },
    ],
    mobile: { right: '8%', top: '35%', width: '60%', stacked: true },
  },
  {
    page: '21',
    variant: 'banner',
    left: '10%',
    bottom: '10%',
    content: [
      { type: 'number', value: 119, emphasis: true, },
      { type: 'text', value: 'metric tons of sand to hide floors\nthat didn’t belong in the past.', mobileValue: 'metric tons of\nsand to hide\nfloors that\ndidn’t belong in\nthe past.' },
    ],
    mobile: { left: '5%', bottom: '-20%', width: '40%', stacked: true },
  },
  {
    page: '23',
    variant: 'banner',
    right: '4%',
    top: '12%',
    parallax: 0,
    content: [
      { type: 'number', value: 280, emphasis: true, },
      { type: 'text', value: 'minutes in the first cut.\nThat’s 4 hours and 40 minutes.' },
    ]
  },
  {
    page: '25',
    variant: 'banner',
    right: '10%',
    top: '12%',
    content: [
      { type: 'number', value: 157, emphasis: true, },
      { type: 'text', value: 'musicians heard\nin the film', mobileValue: 'musicians heard in the film' },
    ],
    mobile: { right: '5%', bottom: '25%', width: '60%' },
  },
  {
    page: '26',
    variant: 'banner',
    right: '0%',
    top: '40%',
    content: [
      { type: 'number', value: 300, emphasis: true, },
      { type: 'text', value: 'prosthetic makeup pieces\nto create Rafael’s wounds.', mobileValue: 'prosthetic makeup pieces to create Rafael’s wounds.' },
    ],
    mobile: { left: '8%', bottom: '15%', width: '80%' },
  },
  {
    page: '28',
    variant: 'banner',
    right: '10%',
    top: '10%',
    content: [
      { type: 'number', value: 400, suffix: '+', emphasis: true, },
      { type: 'text', value: 'wigs\nstyled' },
    ],
    mobile: { left: '45%', top: '28%', width: '45%' },
  },
  {
    page: '29',
    variant: 'banner',
    left: '21%',
    top: '40%',
    content: [
      { type: 'number', value: 3000, suffix: '+', emphasis: true, },
      { type: 'text', value: 'extras' },
    ],
    mobile: { right: '8%', bottom: '8%', width: '50%' },
  },
  {
    page: '34',
    variant: 'banner',
    right: '10%',
    top: '35%',
    content: [
      { type: 'number', value: 1332, emphasis: true, },
      { type: 'text', value: 'bars of original music\ncomposed for the film.', mobileValue: 'bars of original music composed for the film.' },
    ],
    mobile: { left: '10%', top: '-35%', width: '80%' },
  },
  {
    page: '37',
    variant: 'banner',
    right: '-33%',
    bottom: '17%',
    content: [
      { type: 'number', value: 4, suffix: ' PAGES', emphasis: true, },
      { type: 'text', value: 'handwritten by\nFederico García Lorca.', mobileValue: 'handwritten by\nFederico García Lorca.' },
    ],
    mobile: { left: '5%', bottom: '2%', width: '90%' },
  },
];

export default statisticDefinitions;